module.exports = __webpack_public_path__ + "static/media/Outside Dining 2.d4dfd05b.jpg";